import { OwnerTypes } from "@/domain/_shared/lib/owner-types";

export interface InstanceWithOwnerType {
  ownerType?: string;
}

export interface InstanceCounts {
  climateActionCount: number;
  projectCount: number;
}

/**
 * Counts climate actions and projects from a list of instances with ownerType
 *
 * @param instanceList - Array of instances that have an ownerType property
 * @returns Object with climateActionCount and projectCount
 */
export function countInstancesByOwnerType(instanceList?: Array<InstanceWithOwnerType>): InstanceCounts {
  if (!instanceList || !instanceList.length) {
    return { climateActionCount: 0, projectCount: 0 };
  }

  const climateActionCount = instanceList.filter((instance) => instance.ownerType === OwnerTypes.CLIMATE_ACTION).length;
  const projectCount = instanceList.filter((instance) => instance.ownerType === OwnerTypes.PROJECT).length;

  return { climateActionCount, projectCount };
}
